module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "material-table-widget dashboard_top_bar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('h3', {
    staticClass: "text-center",
    staticStyle: {
      "margin": "6px 0px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.filter_year) + "年度組織分析 - " + _vm._s(_vm.current_client_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-inline text-right display-block"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_year),
      expression: "filter_year"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.queryData]
    }
  }, _vm._l((_vm.year_range), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_sales),
      expression: "filter_sales"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_sales = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.queryData]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("所有客戶")]), _vm._v(" "), _vm._l((_vm.company_clients), function(client) {
    return _c('option', {
      domProps: {
        "value": client.client_tag
      }
    }, [_vm._v(_vm._s(client.client_name))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap padding-0"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.deals_title), function(title) {
    return _c('div', {
      staticClass: "col"
    }, [(title == 'won') ? _c('h4', {
      staticClass: "text-success"
    }, [_vm._v("已成交訂單 "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("+")])]) : (title == 'open') ? _c('h4', {
      staticClass: "text-wanring"
    }, [_vm._v("洽談中訂單 "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("+")])]) : (title == 'lost') ? _c('h4', {
      staticClass: "text-danger"
    }, [_vm._v("已丟失訂單 "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("=")])]) : (title == 'all') ? _c('h4', {
      staticClass: "text-info"
    }, [_vm._v("總訂單")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dealCount(title)) + "筆 / " + _vm._s(_vm.dealTotal(title)) + " / " + _vm._s(_vm.dealRate(title)))])])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("平均成交定金額(成交總金額/成交總數) = " + _vm._s(_vm.avgPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap padding-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.stages_name), function(name) {
    return _c('div', {
      staticClass: "col"
    }, [_c('h4', [_vm._v(_vm._s(name))]), _vm._v(" "), _c('p', [_vm._v("總共" + _vm._s(_vm.stages_data[name]) + "筆 "), _c('span', {
      staticClass: "badge badge-pill badge-primary"
    }, [_vm._v(_vm._s(_vm.stageRate(_vm.stages_data[name])))])]), _vm._v(" "), _c('p', [_vm._v("轉換率 "), _c('span', {
      staticClass: "badge badge-pill badge-primary"
    }, [_vm._v(_vm._s(_vm.transferRate(_vm.stages_data[name], name)))])])])
  }))])])]), _vm._v(" "), _vm._m(1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("各階段轉換率")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-wrap padding-0"
  }, [_c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("每月概覽")])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartdiv"
    }
  }), _vm._v("\n\n              圖表放置區\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9574537a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Analytics/Clients.vue
// module id = 706
// module chunks = 4